import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';


import logo from '../images/logo_onlineico_goldv1.png';


export default function Navbar() {
    const navigate = useNavigate();
    const { user, logoutUser } = useAuth();
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    const goTo = (path) => { navigate(path); closeMenu(); };
    const handleLogout = () => { logoutUser(); navigate('/'); closeMenu(); };

    return (
        <>
            <nav className="nav" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative' }}>

                {/* GAUCHE — Logo */}
                <div className="nav-logo" style={{ cursor: 'pointer', flexShrink: 0 }} onClick={() => goTo('/')}>
                   

                    <img 
      src={logo}
      alt="Reward Payment Interface"
      className="img-fluid rounded-"
      style={{
        transition: 'transform 0.3s ease',
        display: 'block'
      }}
      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
    />
                </div>

                {/* CENTRE — Menu desktop */}
                <div className="nav-menu-desktop" style={{ display: 'flex', gap: '2rem', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
                    <span className="nav-mobile-item" onClick={() => goTo('/')}>◧ Home</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/listings')}>📋 Listings</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/earn')}>⚡ Earn</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/calendar')}>🗓 Calendar</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/token-studio')}>🎨 Token Studio</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/add-crypto-project-ico')}>🚀 List Your Project</span>
                </div>

                {/* DROITE — Auth desktop + hamburger mobile */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>

                    {/* Auth visible sur desktop */}
                    <div className="nav-auth-desktop">
                        {user ? (
                            <>
                                <span
                                    style={{ color: user.role === 'admin' ? '#F59E0B' : user.role === 'participant' ? '#a78bfa' : '#34D399', fontSize: '0.85rem', cursor: 'pointer', marginRight: '8px' }}
                                    onClick={() => goTo(user.role === 'admin' ? '/admin' : user.role === 'participant' ? '/mon-espace' : '/mon-compte')}>
                                    {user.role === 'admin' ? '⚙' : '👤'} {user.username}
                                </span>
                                <button className="submit-nav-btn"
                                    style={{ background: 'rgba(255,255,255,0.05)', color: '#94a3b8', border: '1px solid rgba(255,255,255,0.1)' }}
                                    onClick={handleLogout}>
                                    Logout
                                </button>
                            </>
                        ) : (
                            <button className="submit-nav-btn" onClick={() => goTo('/connexion')}>Login</button>
                        )}
                    </div>

                    {/* Bouton hamburger — mobile uniquement */}
                    <button
                        className="nav-hamburger"
                        onClick={() => setMenuOpen(o => !o)}
                        aria-label="Menu"
                        style={{
                            display: 'none',
                            flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                            gap: '5px', width: '36px', height: '36px',
                            background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
                            borderRadius: '8px', cursor: 'pointer', padding: '0', flexShrink: 0
                        }}
                    >
                        <span style={{ width: '18px', height: '2px', background: menuOpen ? '#34D399' : '#94a3b8', borderRadius: '2px', transition: 'all 0.2s', transform: menuOpen ? 'rotate(45deg) translateY(7px)' : 'none' }} />
                        <span style={{ width: '18px', height: '2px', background: menuOpen ? 'transparent' : '#94a3b8', borderRadius: '2px', transition: 'all 0.2s' }} />
                        <span style={{ width: '18px', height: '2px', background: menuOpen ? '#34D399' : '#94a3b8', borderRadius: '2px', transition: 'all 0.2s', transform: menuOpen ? 'rotate(-45deg) translateY(-7px)' : 'none' }} />
                    </button>
                </div>
            </nav>

            {/* MENU MOBILE déroulant */}
            {menuOpen && (
                <div className="nav-mobile-menu" style={{
                    position: 'fixed', top: '64px', left: 0, right: 0, zIndex: 99,
                    background: 'rgba(11,17,32,0.97)', backdropFilter: 'blur(20px)',
                    borderBottom: '1px solid rgba(255,255,255,0.07)',
                    padding: '16px 1.5rem 24px', display: 'flex', flexDirection: 'column', gap: '4px'
                }}>
                    <span className="nav-mobile-item" onClick={() => goTo('/')}>◧ Home</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/listings')}>📋 Listings</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/earn')}>⚡ Earn</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/calendar')}>🗓 Calendar</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/token-studio')}>🎨 Token Studio</span>
                    <span className="nav-mobile-item" onClick={() => goTo('/add-crypto-project-ico')}>🚀 List Your Project</span>

                    <div style={{ height: '1px', background: 'rgba(255,255,255,0.07)', margin: '10px 0' }} />

                    {user ? (
                        <>
                            <span className="nav-mobile-item"
                                style={{ color: user.role === 'admin' ? '#F59E0B' : user.role === 'participant' ? '#a78bfa' : '#34D399' }}
                                onClick={() => goTo(user.role === 'admin' ? '/admin' : user.role === 'participant' ? '/mon-espace' : '/mon-compte')}>
                                {user.role === 'admin' ? '⚙ Admin' : user.role === 'participant' ? '🎯 My space' : '👤 My account'} — {user.username}
                            </span>
                            <button
                                onClick={handleLogout}
                                style={{
                                    marginTop: '8px', padding: '12px', borderRadius: '12px',
                                    background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)',
                                    color: '#f87171', fontWeight: '600', fontSize: '0.9rem',
                                    cursor: 'pointer', fontFamily: 'Inter, sans-serif'
                                }}
                            >
                                Logout
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={() => goTo('/connexion')}
                            style={{
                                marginTop: '8px', padding: '12px', borderRadius: '12px',
                                background: 'linear-gradient(135deg, #34D399, #10B981)',
                                border: 'none', color: '#0B1120', fontWeight: '700',
                                fontSize: '0.9rem', cursor: 'pointer', fontFamily: 'Inter, sans-serif'
                            }}
                        >
                            Login
                        </button>
                    )}
                </div>
            )}
        </>
    );
}
